module.exports = {
  global: {
    dimensions: {
      height: 0,
      width: 0,
    }
  }
};
